// extracted by mini-css-extract-plugin
export default {"primaryTitle":"FkZ_z","userPersona":"nUHVm","mailSurfaceHeader":"Al2ko","hasSecondaryHeader":"kpzET","icon":"LGJRi","isButtonPressed":"lqpmH"};